import axios from "axios";
import JwtService from "@/core/services/jwt.service";

const ValoraApiService = axios.create({
  baseURL: process.env.VUE_APP_VALORA_API,
  timeout: 30000
});

ValoraApiService.interceptors.request.use((config) => {
  const token = JwtService.getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const buscarCardsDashboard = (filtros) =>
  ValoraApiService.post("v1/kpis/dashboard_comunicante", filtros);

export default ValoraApiService;
